(function () {
  'use strict';

  function reveal(root) {
    var scope = root || document;
    var elements = Array.from(scope.querySelectorAll('[data-ciari-reveal]:not([data-reveal-ready])'));

    elements.forEach(function (element) {
      element.setAttribute('data-reveal-ready', '');

      if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        element.setAttribute('data-revealed', '');
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;

        element.setAttribute('data-revealed', '');
        observer.disconnect();
      }, {
        threshold: 0.25,
        rootMargin: '0px 0px -10% 0px'
      });

      observer.observe(element);
    });
  }

  window.CiariScrollReveal = window.CiariScrollReveal || { reveal: reveal };
  window.CiariScrollReveal.reveal(document);

  if (!window.CiariScrollReveal.sectionListenerAdded) {
    document.addEventListener('shopify:section:load', function (event) {
      window.CiariScrollReveal.reveal(event.target);
    });
    window.CiariScrollReveal.sectionListenerAdded = true;
  }
})();
